<template>
	<div
		class="RecoverPassword is-flex is-align-items-center is-flex-direction-column"
	>
		<div style="width: 500px; max-width: 90%; padding-top: 15px;" class="mb-5" >
			<img src="@/assets/logo.svg" />
		</div>
		<div class="RecoverPassword-Form">
			<form @submit.prevent="onSubmit">
				<div class="p-6">
					<h1 class="RecoverPassword-Title">{{ $t('recoverpassword.title') }}</h1>
					<div>
						<div class="field">
							<label
								class="label has-text-white" for="email"
							>{{ $t('recoverpassword.email_label') }}</label
							>
							<p class="control has-icons-left">
								<input
									required
									id="email"
									class="input"
									type="email"
									:placeholder="$t('recoverpassword.email_placeholder')"
									v-model="formData.email"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-envelope"></i>
								</span>
							</p>
						</div>
						<p class="has-text-white is-size-7">
							{{ $t('recoverpassword.instructions') }}
						</p>
						<progress
							v-if="isPending"
							class="progress is-small is-primary mt-5"
							max="100"
						/>
						<span v-if="error" class="tag is-danger is-medium is-light mt-5">{{ $t('recoverpassword.error') }}</span>
						<p v-if="successFeedback" class="has-text-success is-medium mt-5">
							{{ $t('recoverpassword.success') }}
						</p>
					</div>
				</div>
				<div
					class="RecoverPassword-Actions px-6 py-4 is-flex is-align-items-center is-justify-content-space-between"
				>
					<router-link
						style="color: #ef7c21; text-decoration: underline;"
						to="/login"
					>{{ $t('recoverpassword.back') }}</router-link
					>
					<button class="button is-info" type="submit" :disabled="isPending">
						{{ $t('recoverpassword.submit') }}
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>

export default {
	data: () => ({
		formData: {
			email: '',
			langCode: ''
		},

		isPending: false,
		error: '',
		successFeedback: ''
	}),

	methods: {
		async onSubmit() {
			this.isPending = true;
			this.successFeedback = false;
			this.error = false;

			this.formData.langCode = this.$i18n.locale ?? 'sv';

			try {
				await this.$services.user.resetPassword(this.formData);
				this.successFeedback = true;
				this.formData.email = '';
			} catch (error) {
				this.error = true;
			} finally {
				this.isPending = false;
			}
		}
	}
};
</script>

<style>
.RecoverPassword {
  width: 100vw;
  height: 100vh;
  background: #23282d;
}

.RecoverPassword-Form {
  width: 500px;
  max-width: 90%;
  background-color: #363a41;
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border: 1px solid #4a4e58;
}

.RecoverPassword-Title {
  color: white;
  margin-bottom: 40px;
  margin-top: 20px;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 0.08rem;
}

.RecoverPassword-Actions {
  background-color: #2d3138;
  border-top: 1px solid #4a4e58;
}
</style>
